import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Sun, Moon, Monitor } from "@/components/icons";
import { useTheme } from "./useTheme";

export function ThemeSelect() {
  const { preference, setPreference } = useTheme();
  const { t } = useTranslation("preferences");

  return (
    <RadioGroup
      value={preference}
      onValueChange={(v) => setPreference(v as "light" | "dark" | "system")}
      className="grid grid-cols-3 gap-3"
    >
      <ThemeOption value="light" label={t("appearance.light")} icon={Sun} />
      <ThemeOption value="dark" label={t("appearance.dark")} icon={Moon} />
      <ThemeOption value="system" label={t("appearance.system")} icon={Monitor} />
    </RadioGroup>
  );
}

function ThemeOption({
  value,
  label,
  icon: Icon,
}: {
  value: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}) {
  return (
    <Label
      htmlFor={`theme-${value}`}
      className="flex flex-col items-center gap-2 rounded-md border border-border p-4 cursor-pointer hover:bg-muted has-[input:checked]:border-primary has-[input:checked]:bg-accent"
    >
      <RadioGroupItem id={`theme-${value}`} value={value} className="sr-only" />
      <Icon className="h-5 w-5" />
      <span className="text-sm">{label}</span>
    </Label>
  );
}
